import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { AddButton } from '@/common/buttons/AddButton'
import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { StringUtils } from '@/common/utils/StringUtils';
import { useCallback, useState } from 'react';

export const CustRelList = ({ custId }) => {

  // This mode tracks this Ndc11's status as the Parent or Child of the relationships
  // Hence, the Tab names will be opposite of the mode
  const [mode, setMode] = useState('parent');

  const handleChange = (
    event,
    newMode
  ) => {
    if (newMode !== null) {
      setMode(newMode);
    }
  };

  const augRowsReq = useCallback((rowsReq) => {
    if (!custId) return
    const addlExpr = ExprUtils.whereParams(mode + 'CustId', custId)
    rowsReq.expr = ExprUtils.and(rowsReq.expr, addlExpr)
  }, [custId, mode])

  // Augment nav FK's to match ProdRel entity Parent / Child
  const augNavEntityObj = (navEntityObj) => {
    Object.keys(navEntityObj).forEach(key => {
      navEntityObj[mode + StringUtils.capitalizeFirstLetter(key)] = navEntityObj[key];
      delete navEntityObj[key];
    });
  }

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
    tabButtons.push(   
    <ToggleButtonGroup
      value={mode}
      exclusive
      onChange={handleChange}
    >
      <ToggleButton value="parent" aria-label="parent" data-test-id="toggle-parent">
        Children
      </ToggleButton>
      <ToggleButton value="child" aria-label="child" data-test-id="toggle-child">
        Parents
      </ToggleButton>
    </ToggleButtonGroup>,

    // Add button 
    <AddButton entity="CUST_REL" augNavEntityObj={augNavEntityObj}></AddButton>);
  }

  return (
    <EntityList key={mode} entity="CUST_REL" augTabButtons={augTabButtons} augRowsReq={augRowsReq}/>
  )
}